import { render, staticRenderFns } from "./DicomLandmark.vue?vue&type=template&id=72a7f98a&scoped=true&"
import script from "./DicomLandmark.vue?vue&type=script&lang=js&"
export * from "./DicomLandmark.vue?vue&type=script&lang=js&"
import style0 from "./DicomLandmark.vue?vue&type=style&index=0&id=72a7f98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7f98a",
  null
  
)

export default component.exports